import { contractDate } from '../utils/planningDates';
import axios from "../axios/AxiosInstance";
export const QUOTE_STATES = [
  "Créé",
  "Envoyé",
  "En négociation",
  "Signé",
  "Refusé",
  "Remplacé",
];
export function quoteTransition(
  current,
  { state, note, author, signer, signedAt, fileKey, revisionId },
  now = new Date(),
) {
  if (['Signé', 'Remplacé'].includes(current?.state)) throw new Error('Ce devis est finalisé. Son historique est conservé.');
  if (!QUOTE_STATES.includes(state)) throw new Error("État invalide");
  if (["Refusé", "En négociation"].includes(state) && !note?.trim())
    throw new Error("Précisez le motif ou les modifications demandées.");
  if (state === "Signé" && (!signer?.trim() || !contractDate(signedAt) || !fileKey))
    throw new Error("Indiquez le signataire, la date et le PDF signé.");
  if (state === "Remplacé" && !revisionId)
    throw new Error(
      "La nouvelle version doit être créée avant de remplacer le devis.",
    );
  const event = {
    state,
    note: note?.trim() || "",
    author,
    savedAt: now.toISOString(),
    signer,
    signedAt,
    fileKey,
    revisionId,
  };
  return {
    ...current,
    state,
    revisionId: revisionId || current?.revisionId,
    history: [event, ...(current?.history || [])],
  };
}
export function quotationEmail(quotation, client, recipient, note = "") {
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipient) || /[\r\n]/.test(recipient))
    throw new Error("Indiquez un email valide.");
  const subject = `J’M Intérim — Devis n° ${quotation.quotationNumber ?? "Provisoire"}`;
  const body = `Bonjour,\n\nVous trouverez en pièce jointe notre devis n° ${quotation.quotationNumber ?? "Provisoire"} pour ${client.companyName || "votre établissement"}.\n\n${note.trim() ? `${note.trim()}\n\n` : ""}Merci de nous retourner le devis signé ou de nous préciser les ajustements souhaités.\n\nCordialement,\nJ’M Intérim`;
  return `mailto:${encodeURIComponent(recipient)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
export function checkSignedQuoteFile(file) {
  if (file?.type !== "application/pdf" || file.size > 10 * 1024 * 1024)
    throw new Error("Choisissez un PDF de 10 Mo maximum.");
}
export async function saveQuoteWorkflow(
  quotationId,
  { state, note, signer, signedAt, file, revisionId },
) {
  if (file) checkSignedQuoteFile(file);
  const body = new FormData();
  body.append("state", state);
  if (note) body.append("note", note);
  if (signer) body.append("signer", signer);
  if (signedAt) body.append("signedAt", signedAt);
  if (revisionId) body.append("revisionId", revisionId);
  if (file) body.append("file", file);
  try {
    const { data } = await axios.post(`quotation/${quotationId}/workflow`, body);
    return data?.workflow || {};
  } catch (error) {
    throw new Error(error.response?.data?.message || "Enregistrement impossible.");
  }
}
export async function downloadSignedQuote(quotationId) {
  const { data } = await axios.get(`quotation/${quotationId}/signed-pdf`);
  const bytes = Uint8Array.from(atob(data.data), (char) => char.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = data.name;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
